import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@folio/stripes/components';
import css from './SafeDeleteInstancePage.css';

const StatusIndicator = ({
  isSuccess = false,
  size = 'medium',
  successColor,
  errorColor,
  style = {},
}) => {
  const statusClass = isSuccess
    ? css.statusIndicatorSuccess
    : css.statusIndicatorError;
  const className = `${css.statusIndicator} ${statusClass}`;

  const customStyles = { ...style };
  if (successColor && isSuccess) customStyles.color = successColor;
  if (errorColor && !isSuccess) customStyles.color = errorColor;

  return (
    <Icon
      icon={isSuccess ? 'check-circle' : 'exclamation-circle'}
      size={size}
      className={className}
      style={customStyles}
    />
  );
};

StatusIndicator.propTypes = {
  isSuccess: PropTypes.bool,
  size: PropTypes.string,
  successColor: PropTypes.string,
  errorColor: PropTypes.string,
  style: PropTypes.object,
};

export default StatusIndicator;
